export const home = {
  // Navbar
  navbar: {
    home: 'Home',
    products: 'Products',
    cases: 'Cases',
    about: 'About',
    contact: 'Contact',
    language: {
      zh: '中文',
      en: 'English'
    }
  },
  
  // Hero
  hero: {
    slides: [
      {
        title: 'Innovative Technology Solutions',
        description: 'Providing cutting-edge technology support and digital transformation solutions for enterprises'
      },
      {
        title: 'Smart Manufacturing Management Platform',
        description: 'Autonomous and controllable system platform integrating IT/OT/AI technologies'
      },
      {
        title: 'Operational Excellence Management System',
        description: 'Achieving seamless and efficient communication between enterprise management and frontline employees'
      }
    ]
  },
  
  // Solutions
  solutions: {
    title: 'Solutions',
    subtitle: 'Providing reliable smart manufacturing solutions for users',
    viewDetails: 'View Details',
    close: 'Close',
    productIntro: 'Product Introduction',
    coreFeatures: 'Core Features',
    items: [
      {
        title: 'OPEX Platform',
        subtitle: 'Supported Systems: Android, iOS',
        description: 'Operational Excellence Management',
        detail: 'Autonomous and controllable system platform integrating next-generation IT/OT/AI technologies',
        fullDescription: 'OPEX Platform is an autonomous and controllable system platform integrating next-generation IT/OT/AI technologies, focusing on operational excellence management. Through intelligent data analysis and process optimization, it helps enterprises achieve comprehensive improvement in operational efficiency.',
        features: [
          'Intelligent data analysis and visualization',
          'Real-time operational monitoring and alerts',
          'Process automation and optimization',
          'Cross-platform mobile support',
          'Autonomous and controllable security architecture'
        ]
      },
      {
        title: 'On-site Safety Manager',
        subtitle: 'Supported Systems: Android, iOS',
        description: 'Achieving seamless communication',
        detail: 'between enterprise management and frontline employees',
        fullDescription: 'On-site Safety Manager is committed to achieving seamless and efficient communication between enterprise management and frontline employees. Through mobile and intelligent safety management tools, it comprehensively improves on-site safety management.',
        features: [
          'Real-time safety hazard reporting',
          'Intelligent inspection and task assignment',
          'Multi-level approval process management',
          'Safety training and assessment',
          'Data statistics and analysis reports'
        ]
      },
      {
        title: 'Lightweight Production MES',
        subtitle: 'Supported Systems: Android, iOS',
        description: 'Optimized architecture design for rapid deployment',
        detail: '',
        fullDescription: 'Lightweight Production MES system adopts optimized architecture design to achieve rapid deployment and flexible configuration. It helps manufacturing enterprises quickly establish production execution management systems and improve production efficiency and product quality.',
        features: [
          'Rapid deployment and configuration',
          'Production planning and scheduling',
          'Real-time production monitoring',
          'Quality management and traceability',
          'Equipment management and maintenance'
        ]
      },
      {
        title: 'Lightweight Warehouse WMS',
        subtitle: 'Supported Systems: Android, iOS',
        description: 'Reducing material abnormal loss',
        detail: 'Reducing obsolete material loss caused by process changes',
        fullDescription: 'Lightweight Warehouse WMS system focuses on reducing material abnormal loss. Through intelligent inventory management and early warning mechanisms, it effectively reduces obsolete material loss caused by process changes and improves warehouse management efficiency.',
        features: [
          'Intelligent inventory management',
          'Material traceability and alerts',
          'Automated inbound and outbound operations',
          'Obsolete material analysis and handling',
          'Real-time mobile operations'
        ]
      }
    ]
  },
  
  // Service Process
  serviceProcess: {
    title: 'Service Process',
    subtitle: 'Customer-centric, creating brands through efficient service',
    steps: [
      {
        title: 'Requirements Communication',
        description: 'Listen to customer needs, understand user environment and operational processes'
      },
      {
        title: 'Contract Signing',
        description: 'Conduct business negotiations and sign contracts based on customer requirements'
      },
      {
        title: 'Interaction Design',
        description: 'Brainstorm interaction scenarios and prototype design'
      },
      {
        title: 'Solution Confirmation',
        description: 'Confirm development plan based on business requirements and prototype design'
      },
      {
        title: 'Technical Development',
        description: 'Mobile application data integration and development'
      },
      {
        title: 'Testing and Feedback',
        description: 'Modification and adjustment, standardization and improvement'
      },
      {
        title: 'Follow-up Service',
        description: 'Subsequent maintenance and continuous follow-up'
      }
    ]
  },
  
  // Case Studies
  caseStudies: {
    title: 'Customer Cases',
    subtitle: 'Serving numerous well-known enterprises, facilitating digital transformation and upgrading',
    projectOverview: 'Project Overview',
    coreFeatures: 'Core Features',
    implementationResults: 'Implementation Results',
    close: 'Close',
    cases: [
      {
        title: 'UO On-site Safety Manager',
        category: 'Safety Management System',
        description: 'On-site safety management system built for UO Group, achieving full-process digital management of real-time safety hazard monitoring, risk warning, and emergency response.',
        highlights: ['Real-time Monitoring', 'Risk Warning', 'Emergency Response', 'Data Analysis'],
        results: 'Safety accident rate reduced by 85%, hazard handling efficiency increased by 300%'
      },
      {
        title: 'AUX QMS',
        category: 'Quality Management System',
        description: 'Comprehensive quality management system developed for AUX Group, covering the entire process of quality planning, quality control, quality assurance, and quality improvement.',
        highlights: ['Quality Traceability', 'Defective Product Management', 'Supplier Evaluation', 'Continuous Improvement'],
        results: 'Product qualification rate increased to 99.5%, customer complaints reduced by 70%'
      },
      {
        title: 'Double Star Tire MES',
        category: 'Manufacturing Execution System',
        description: 'Smart manufacturing execution system built for Double Star Tire, achieving real-time monitoring, data collection, and intelligent scheduling of production processes.',
        highlights: ['Production Scheduling', 'Equipment Networking', 'Quality Traceability', 'Energy Management'],
        results: 'Production efficiency increased by 40%, energy consumption reduced by 25%'
      },
      {
        title: 'FAW WMS',
        category: 'Warehouse Management System',
        description: 'Intelligent warehouse management system developed for FAW, achieving full-process automation and intelligence of inbound, outbound, and inventory management.',
        highlights: ['Intelligent Scheduling', 'Location Optimization', 'Automatic Inventory', 'Data Visualization'],
        results: 'Warehouse efficiency increased by 60%, inventory accuracy reached 99.8%'
      },
      {
        title: 'Suzhou Feima MES',
        category: 'Manufacturing Execution System',
        description: 'Customized MES system for Suzhou Feima, achieving full-process digital management and intelligent control from order to delivery.',
        highlights: ['Order Management', 'Production Scheduling', 'Process Management', 'Equipment Monitoring'],
        results: 'On-time delivery rate increased to 98%, production cycle shortened by 35%'
      },
      {
        title: 'Beiyuan Electric SRM',
        category: 'Supplier Relationship Management',
        description: 'Supplier relationship management platform built for Beiyuan Electric, achieving full lifecycle management and collaboration of suppliers.',
        highlights: ['Supplier Evaluation', 'Procurement Collaboration', 'Quality Control', 'Performance Analysis'],
        results: 'Procurement cost reduced by 18%, supply chain response speed increased by 50%'
      }
    ]
  },
  
  // Partners
  partners: {
    title: 'Partners',
    strategicPartner: 'Strategic Partner',
    companyIntro: 'Company Introduction',
    cooperation: 'Cooperation Content',
    close: 'Close',
    list: [
      {
        name: 'VanCut',
        description: 'VanCut is a leading enterprise focusing on smart manufacturing solutions, committed to providing efficient production management systems for the manufacturing industry.',
        cooperation: 'Cooperate with AiMS to develop intelligent production management systems and achieve digital transformation of production processes.'
      },
      {
        name: 'Phoenix Contact',
        description: 'Phoenix Contact is a global market leader in electrical connections, electronic interface technology, and industrial automation.',
        cooperation: 'Conduct in-depth cooperation in industrial automation and smart manufacturing, jointly promoting Industry 4.0 solutions.'
      },
      {
        name: 'CEPD',
        description: 'CEPD focuses on enterprise digital transformation, providing comprehensive information solutions and technical support.',
        cooperation: 'Work together to build enterprise-level digital platforms and help enterprises achieve intelligent management.'
      },
      {
        name: 'Beyone',
        description: 'Beyone is an innovative technology company focusing on providing intelligent business management solutions for enterprises.',
        cooperation: 'Jointly develop intelligent business management systems to improve enterprise operational efficiency.'
      },
      {
        name: 'Hardware & Electromechanical Association',
        description: 'The Hardware & Electromechanical Industry Association is committed to promoting the development of the hardware and electromechanical industry, providing member enterprises with technical exchanges, market information, and industry standard formulation services.',
        cooperation: 'Establish strategic cooperation in the digital transformation of the hardware and electromechanical industry, jointly promoting intelligent upgrading of the industry.'
      },
      {
        name: 'KANGDA',
        description: 'Kangda Group is a comprehensive enterprise group with businesses covering manufacturing, technology, services, and other fields.',
        cooperation: 'Conduct comprehensive cooperation in smart manufacturing and enterprise informatization.'
      },
      {
        name: 'CETC',
        description: 'China Electronics Technology Group is a leading domestic electronic information technology enterprise with deep strength in information security and intelligent systems.',
        cooperation: 'Establish long-term strategic partnerships in enterprise informatization and intelligent system integration.'
      }
    ]
  },
  
  // About
  about: {
    title: 'About AiMS',
    subtitle: 'Focusing on enterprise digital solutions, facilitating enterprise digital transformation',
    companyIntro: 'Company Introduction',
    vision: 'Vision',
    mission: 'Mission',
    coreValues: 'Core Values',
    introduction: 'AiMS (Beijing) Technology Co., Ltd. is a high-tech enterprise focusing on enterprise digital solutions. We are committed to providing professional software development and system integration services for manufacturing, logistics, and other industries.',
    visionText: 'To become a leading provider of enterprise digital solutions in China, facilitating enterprise digital transformation.',
    missionText: 'Through innovative technology and professional services, help enterprises improve management efficiency, reduce operating costs, and achieve sustainable development.',
    stats: [
      { number: '20+', label: 'Years of Industry Experience' },
      { number: '200+', label: 'Served Enterprises' },
      { number: '50+', label: 'Professional Team' },
      { number: '98%', label: 'Customer Satisfaction' }
    ],
    values: [
      { title: 'Innovation', description: 'Continuous innovation, leading technology development' },
      { title: 'Professional', description: 'Professional team, striving for excellence' },
      { title: 'Service', description: 'Customer first, attentive service' },
      { title: 'Excellence', description: 'Pursuing excellence, achieving customers' }
    ]
  },
  
  // Footer
  footer: {
    address: 'Address',
    phone: 'Phone',
    fax: 'Fax',
    email: 'Email',
    addressContent: ['Beijing HQ: Building C, Yingdu Tower, Zhichun Road, Haidian District, Beijing', 'Liaoning Branch: Honghao City, Lishan District, Anshan, Liaoning Province'],
    phoneContent: ['Tel: +86-10-52471922'],
    faxContent: ['Fax: +86-10-52471929'],
    emailContent: ['Email: yourbestanswer@163.com'],
    copyright: 'AiMS ©2012-2025 京ICP备12014991号-1 京公安网安备11010802012650',
    backToTop: 'Back to Top'
  }
};
